<!-- 数据字典 -->
<template>
<div>
	<!-- 标题 -->
	<div class="page-title">数据字典</div>
	
	<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 15px;position: sticky;left: 30px;z-index: 5;width: 860px;">
		
		<!-- <div class="screen-box">
			<div class="screen-label">搜索</div>
			<a-input v-model="r_search" placeholder="请输入" style="width: 240px;"/>
		</div> -->
		
		<!-- <a-button @click="searchButton" :loading="search_button_loading" type="primary" icon="search" style="margin-right: 20px;">搜索</a-button> -->
		<a-button @click="addButton" style="background-color: #67c23a;border-color: #67c23a;" type="primary">+ 新增</a-button>
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div  v-for="(item,index) in rableTitle" :key="index" >
				<div class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		
			<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
				<!-- ID -->
				<div class="table-td-cell" :style="{'width':rableTitle[0].width + 'px'}">
					{{item.id}}
				</div>
				<!-- 名称 -->
				<div  class="table-td-cell" :style="{'width':rableTitle[1].width + 'px'}">
					{{item.name}}
				</div>
				<!-- 描述 -->
				<div  class="table-td-cell" :style="{'width':rableTitle[2].width + 'px'}">
					{{item.text}}
				</div>
				<!-- 是否启用 -->
				<div  class="table-td-cell" :style="{'width':rableTitle[3].width + 'px'}">
					<a-switch @change="statusChange($event,item)" :checked="item.status_checked" :loading="item.status_loading" size="small" checked-children="启用" un-checked-children="关闭" />
				</div>
				<!-- 操作 -->
				<div @click="editTable(index,item)" class="table-td-cell" :style="{'width': rableTitle[4].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
					编辑
				</div>
				
			</div>
		
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_scroll_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
	</div>
	
	<!-- 分页 -->
	<div :style="{'width': table_scroll_width + 'px',}" style="text-align: center;margin-top: 30px;">
		
			<a-pagination v-model="r_page" :pageSize="20" :total="table_total" @change="paginationChange"  />
		
	</div>
	
	<!-- 新增/编辑的侧边栏 -->
	<a-drawer
	  :title="drawer_title"
	  width="750px"
	  placement="right"
	  :closable="false"
	  :visible="visible"
	  @close="onCloseDrawer"
	>
		<div style="padding: 10px;">
			<div class="form-cell-box">
				<div class="class-title">名称<span class="required-hint">*</span></div>
					
				<a-input v-model="x_name" placeholder="（只能输入字母）" style="width: 500px;"  />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">内容-文本</div>
					
				<a-textarea
				      v-model="x_text"
				      placeholder="请输入 内容-文本"
				      :auto-size="{ minRows: 5, maxRows: 8 }" 
					  style="width: 500px;"
				    />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">Content</div>
					
				<div style="width: 500px;">
					<!-- 标题头 -->
					<div class="table-th" style="top:0">
						<div  v-for="(item,index) in addTableTitle" :key="index" >
							<div class="table-th-cell" 
							:style="{'width':item.width + 'px',}" style="padding: 8px 6px;">
								{{item.title}}
							</div>
						</div>
					</div>
					<!-- 内容 -->
					<div v-for="(item,index) in contentTableData" class="table-td" style="position: relative;">
						<div style="padding: 8px 6px;">
							<a-input v-model="item.key" :style="{'width':addTableTitle[0].width - 12 + 'px',}" style="box-sizing: border-box;" placeholder="请输入key" />
						</div>
						<div style="padding: 8px 6px;">
							<a-input v-model="item.value" :style="{'width':addTableTitle[1].width - 12 + 'px',}" style="box-sizing: border-box;" placeholder="请输入value" />
						</div>
						<div style="padding: 8px 6px;">
							<a-input v-model="item.limit" :style="{'width':addTableTitle[2].width - 12 + 'px',}" style="box-sizing: border-box;" placeholder="请输入limit" />
						</div>
						<div style="padding: 8px 6px;">
							<!-- <a-input v-model="item.sort" :style="{'width':addTableTitle[3].width - 12 + 'px',}" style="box-sizing: border-box;" placeholder="请输入sort" /> -->
							<a-input-number id="inputNumber" v-model="item.sort" :min="0" :max="100000" :style="{'width':addTableTitle[3].width - 12 + 'px',}" placeholder="请输入sort" />
						</div>
						
						<a-icon @click="delContent(item,index)" type="close-circle" style="font-size: 18px;cursor: pointer;position: absolute;right: -30px;" />
					</div>
					<a-button @click="addContent()" type="primary" size="small" style="margin-top: 15px;">
					    添加 +
					</a-button>
				</div>
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">描述</div>
					
				<!-- <a-input v-model="x_remark" placeholder="请输入" style="width: 500px;"  /> -->
				<a-textarea
				      v-model="x_remark"
				      placeholder="请输入 描述"
				      :auto-size="{ minRows: 3, maxRows: 8 }" 
					  style="width: 500px;"
				    />
			</div>
			
			<div class="form-cell-box" style="height: 40px;">
				<div class="class-title">是否启用</div>
					
				<a-switch :checked="x_status" @change="switchChangeB" checked-children="打开" un-checked-children="关闭" />
			</div>
			
			
			
			<div style="color: red;height: 23px;width: 100%;">{{add_form_hint}}</div>
			
			<div class="form-cell-box" style="margin-top: 30px;padding-left: 41px;">
				<a-button @click="addRequest" :loading="add_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
				<a-button @click="onCloseDrawer">取消</a-button>
			</div>
		</div>
	
	</a-drawer>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
	
</div>
</template>

<script>
import { dataDictList, dataDictEditStatus, dataDictAdd, dataDictEdit } from '@/request/api'
export default {
	name: 'dataDictionary_',
	components: {
		
	},
	data() {
		return {
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID", width:80, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"名称", width:260, type:"name", },
				{title:"描述", width:660, type:"text", },
				{title:"是否启用", width:100, type:"status", },
				{title:"操作", width:100, type:"cz", },
				
			],
			tableShowData: [],
			table_scroll_width: 1600,
			
			search_button_loading: false,
			r_search:"",
			r_page: 1,
			table_total: 0,
			
			drawer_title: "新增", // 侧边栏标题
			visible: false,
			add_button_loading: false, // 新增侧边栏的确认按钮加载状态
			add_form_hint: "", // 侧边栏新增表单的验证提示
			// 新增/编辑参数
			x_id: '', // id
			x_name: "", // 名称
			x_text: "", // 内容-文本
			x_remark: "", // 描述
			x_status: false, // 是否启用，true为启用
			addTableTitle: [ // 新增、编辑侧边栏的表格标题
				{title:"Key", width:125, }, 
				{title:"Value", width:125,},
				{title:"Limit", width:125,},
				{title:"Sort", width:125,},
			],
			contentTableData: [
				// {
				// 	key:"",
				// 	value: "",
				// 	limit: "",
				// 	sort: ""
				// }
			],
		}
	},
	mounted(){
		let that = this
		
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			nn = nn + res.width
		})
		that.table_scroll_width = nn + 30
		
		that.searchButton()
		
		
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		// 搜索
		searchButton(){
			let that = this
			
			that.search_button_loading = true
			
			dataDictList({page: that.r_page}).then(res=>{
				console.log("列表结果",res.data.data)
				that.search_button_loading = false
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					that.table_total = res.data.data.total
					
					let data = res.data.data.data
					data.forEach((res,index)=>{
						res.status_checked = false
						res.status_loading = false // 变更状态的加载中状态
						if(res.status == 1){ // 1=开启 0=关闭
							res.status_checked = true
						}
					})
					that.tableShowData = data
				}
				else {
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`其他错误：${res.data.msg}`);
					}
				}
			})
		},
		// 新增
		addButton(){
			let that = this
			that.drawer_title = "新增"
			that.visible = true
		},
		// 编辑
		editTable(index,item){
			let that = this
			console.log("item",item);
			that.drawer_title = "编辑"
			that.x_id = item.id
			that.x_name = item.name // 名称
			that.x_text = item.text // 内容-文本
			that.x_remark = item.remark // 描述
			
			that.contentTableData = item.content
			
			if(item.status == 1){
				that.x_status = true
			}
			else {
				that.x_status = false
			}
			
			that.visible = true
		},
		// 查看权限
		showPermissions(){
			let that = this
			
		},
		// 侧边栏的新增/编辑
		addRequest(){
			let that = this
			console.log("contentTableData",that.contentTableData);
			if(!that.x_name){ // 名称
				// that.add_form_hint = "请填写 名称 ！！！"
				that.$message.warning('请填写 名称 ！！！');
			}
			
			else {
				that.add_form_hint = ""
				that.add_button_loading = true
				
				let r_data = {
					id: that.x_id,
					name: that.x_name,
					text: that.x_text,
					remark: that.x_remark,
					content: that.contentTableData
				}
				if(that.x_status){
					r_data.status = 1 // 表示开启
				}
				else {
					r_data.status = 0 // 表示关闭
				}
				
				if(that.drawer_title === "新增"){
					dataDictAdd(r_data).then(res=>{
						console.log("新增",res)
						that.add_button_loading = false
						
						if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
							that.onCloseDrawer()
							that.$message.success('新增成功');
							that.searchButton()
						}
						else {
							if(res.data.code == 401){ // 未登录
								localStorage.removeItem("access_token");
								that.$router.replace({name: 'login',params: {type:'not_log'}})
								return
							}
							that.$message.error(res.data.msg || "新增失败");
						}
					})
					.catch(err=>{
						console.log(err)
						that.$message.error("新增失败，可能是网络出现问题");
					})
				}
				else if(that.drawer_title === "编辑"){
					dataDictEdit(r_data).then(res=>{
						console.log("编辑",res)
						that.add_button_loading = false
						if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
							that.onCloseDrawer()
							that.$message.success('编辑成功');
							that.searchButton()
						}
						else {
							if(res.data.code == 401){ // 未登录
								localStorage.removeItem("access_token");
								that.$router.replace({name: 'login',params: {type:'not_log'}})
								return
							}
							that.$message.error(res.data.msg || "编辑失败");
						}
					})
					.catch(err=>{
						console.log(err)
						that.$message.error("编辑失败，可能是网络出现问题");
					})
				}
				
			}
			
		},
		// 侧边栏关闭
		onCloseDrawer(){
			if(this.add_button_loading){ // 新增中或编辑中不准关闭侧边栏
				return
			}
			this.visible = false
			this.x_id = ""
			this.x_name = "" // 名称
			this.x_text = "" // 内容-文本
			this.contentTableData = []
			this.x_remark = "" // 描述
			this.x_status = false, // 是否启用，true为启用
			this.add_form_hint = ""
		},
		
		// 分页
		paginationChange(e){
			let that = this
			this.r_page = e
			that.searchButton()
			
		},
		
		
		// 状态切换
		statusChange(e,item){
			let that = this
			console.log("状态切换",e,item);
			item.status_loading = true
			dataDictEditStatus({
				id: item.id
			}).then(res=>{
				console.log("状态切换",res);
				item.status_loading = false
				
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					item.status_checked = e
					if(e){ // 这里的状态也要更新。1=开启 0=关闭
						item.status = 1
					}
					else {
						item.status = 0
					}
					that.$message.success('操作成功');
				}
				else {
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
		},
		
		// 是否启用
		switchChangeB(e){
			console.log(e);
			this.x_status = e
		},
		// 添加
		addContent(){
			let obj = {
				key:"",
				value: "",
				limit: "",
				sort: ""
			}
			this.contentTableData.push(obj)
		},
		// 删除
		delContent(e,index){
			if(this.contentTableData.length > 0){ // 大于0是因为允许为空
				this.contentTableData.splice(index,1)
			}
		}
	}
}
</script>

<style scoped>
.form-cell-box {
	margin-bottom: 20px;
}

</style>